import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ProblemSolution from "@/components/ProblemSolution";
import HowItWorks from "@/components/HowItWorks";
import Features from "@/components/Features";
import Experience from "@/components/Experience";
import Testimonials from "@/components/Testimonials";
import Pricing from "@/components/Pricing";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import EULA from "@/pages/EULA";
import RefundPolicy from "@/pages/RefundPolicy";

function HomePage() {
  return (
    <>
      {/* Cosmic Background Effects */}
      <div className="cosmic-bg">
        <div className="cosmic-orb cosmic-orb-1"></div>
        <div className="cosmic-orb cosmic-orb-2"></div>
        <div className="cosmic-orb cosmic-orb-3"></div>
      </div>

      {/* Main Content */}
      <main className="relative z-10">
        <Hero />
        <ProblemSolution />
        <HowItWorks />
        <Features />
        <Experience />
        <Testimonials />
        <Pricing />
        <FinalCTA />
        <Footer />
      </main>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/eula" element={<EULA />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
